module.exports = __webpack_public_path__ + "static/media/minus-icon.f2112dc1.svg";